import React, { useEffect, useState } from "react";
import { UserPen, X } from "lucide-react";
import { practiceApi } from "../../lib/practiceApi";
import { NamingPanel } from "./NamingPanel";

const KEY = "ingego-naming-intro";
const SNOOZE_DAYS = 7;

const snoozeActive = at => {
  if (!at) return false;
  return (Date.now() - new Date(at).getTime()) < SNOOZE_DAYS * 24 * 3600 * 1000;
};

// Avviso non bloccante: la schermata resta usabile, il pannello si apre solo se l'utente lo chiede.
export const NamingIntroDialog = () => {
  const [total, setTotal] = useState(0);
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    practiceApi("/preferences").then(prefs => {
      if (prefs?.naming_intro_done) { localStorage.setItem(KEY, "1"); return; }
      if (snoozeActive(prefs?.naming_intro_snoozed_at)) return;
      practiceApi("/naming/review").then(res => {
        if (res.total) setTotal(res.total);
        else localStorage.setItem(KEY, "1");
      }).catch(() => {});
    }).catch(() => {});
  }, []);

  async function snooze() {
    setHidden(true); setOpen(false);
    await practiceApi("/preferences", { method: "PUT", body: JSON.stringify({ data: { naming_intro_snoozed: true } }) }).catch(() => {});
  }

  async function done() {
    setHidden(true); setOpen(false);
    localStorage.setItem(KEY, "1");
    await practiceApi("/preferences", { method: "PUT", body: JSON.stringify({ data: { naming_intro_done: true } }) }).catch(() => {});
  }

  if (!total || hidden) return null;

  if (!open) return <div className="naming-intro-banner" data-testid="naming-intro-banner">
    <UserPen size={15} />
    <span><b>{total} anagrafiche</b> da sistemare con la nuova regola cognome e nome.</span>
    <button type="button" className="primary" data-testid="naming-intro-open" onClick={() => setOpen(true)}>Sistemale ora</button>
    <button type="button" className="ghost" data-testid="naming-intro-later" onClick={snooze}>Più tardi</button>
    <button type="button" className="icon-btn" title="Non mostrarlo più" data-testid="naming-intro-dismiss" onClick={done}><X size={14} /></button>
  </div>;

  return <div className="modal-backdrop" data-testid="naming-intro-backdrop">
    <div className="create-modal naming-intro" data-testid="naming-intro-dialog">
      <button type="button" className="modal-close" data-testid="naming-intro-close" onClick={() => setOpen(false)}><X /></button>
      <p className="eyebrow"><UserPen size={13} /> NUOVA REGOLA · COGNOME E NOME</p>
      <h2>Sistemiamo {total} anagrafiche</h2>
      <p className="muted" style={{ fontSize: 12.5, margin: "0 0 12px" }}>
        Da ora tutte le persone si scrivono <b>prima il cognome, poi il nome</b>: ordinamenti e filtri partono sempre dal cognome.
        Qui sotto trovi i dati già inseriti con la divisione proposta. Conferma, correggi o lascia il record così com'è.
        Puoi chiudere quando vuoi: l'avviso resta in alto.
      </p>
      <NamingPanel embedded />
      <div className="practice-inline-actions" style={{ marginTop: 14 }}>
        <button type="button" className="ghost" data-testid="naming-intro-close-panel" onClick={() => setOpen(false)}>Chiudi</button>
        <button type="button" className="primary" data-testid="naming-intro-done" onClick={done}>Ho finito, non mostrarlo più</button>
      </div>
    </div>
  </div>;
};
